import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('main-cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-bg-primary py-16 md:py-24 px-4 overflow-hidden" data-id="element-144">
      {/* Decorative floral SVG */}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-10 pointer-events-none" data-id="element-145">
        <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-146">
          <path d="M100 50C100 50 120 70 120 90C120 110 110 120 100 120C90 120 80 110 80 90C80 70 100 50 100 50Z" fill="#EFCFD3" data-id="element-147" />
          <path d="M100 120C100 120 120 140 120 160C120 180 110 190 100 190C90 190 80 180 80 160C80 140 100 120 100 120Z" fill="#DCCFEA" data-id="element-148" />
          <circle cx="100" cy="100" r="15" fill="#B89BB8" data-id="element-149" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-150">
        <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center" data-id="element-151">
          {/* Text content */}
          <div className="text-center md:text-left order-2 md:order-1" data-id="element-152">
            <motion.h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-heading mb-6 leading-tight" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-153">
              Si la picazón vuelve una y otra vez, esto es lo que nadie te ha
              explicado todavía
            </motion.h1>

            <motion.p className="text-lg md:text-xl text-body mb-8 leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-154">
              La guía práctica y completa sobre candidiasis vaginal: síntomas,
              causas, prevención, recurrencias, señales de alerta y cuándo ir al
              médico. Sin mitos. Sin tecnicismos. Sin alarmismo.
            </motion.p>

            <motion.div className="flex flex-col sm:flex-row md:flex-col lg:flex-row items-center md:items-start lg:items-center justify-center md:justify-start gap-4 lg:gap-6 mb-10" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-155">
              <div className="flex items-center gap-2 text-body" data-id="element-156">
                <CheckCircleIcon className="w-5 h-5 text-button" data-id="element-157" />
                <span data-id="element-158">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-2 text-body" data-id="element-159">
                <CheckCircleIcon className="w-5 h-5 text-button" data-id="element-160" />
                <span data-id="element-161">Guía completa en PDF</span>
              </div>
              <div className="flex items-center gap-2 text-body" data-id="element-162">
                <CheckCircleIcon className="w-5 h-5 text-button" data-id="element-163" />
                <span data-id="element-164">5 bonos premium incluidos</span>
              </div>
            </motion.div>

            <motion.button onClick={scrollToCTA} className="bg-button text-white px-10 py-5 rounded-full text-lg md:text-xl font-semibold hover:bg-[#A88BA8] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-165">
              📥 Quiero mi guía ahora
            </motion.button>
          </div>

          {/* Cover image */}
          <motion.div className="flex justify-center order-1 md:order-2" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-166">
            <div className="relative" data-id="element-167">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-blush to-accent-lilac rounded-2xl blur-2xl opacity-40 transform rotate-3" data-id="element-168"></div>
              <img src="https://cdn.magicpatterns.com/uploads/84z9jJx341cntZP33FYa8v/thumb.png" alt="Candidiasis Vaginal: Lo Que Debes Saber - Portada de la guía" className="relative w-full max-w-sm md:max-w-md mx-auto rounded-2xl shadow-2xl" data-id="element-169" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}